import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EventRepeatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"event_repeat"}/>
}
